<template>
  <v-menu v-model="openAllMenu" :close-on-content-click="false" top max-width="319px" max-height="575px">
    <template v-slot:activator="{ on }">
      <span class="link" v-on="on">Mostrar tudo</span>
    </template>
    <v-card>
      <v-card-title class="card-title font-weight-bold pt-4 pr-4 pb-0">
        {{ cardTitle }}
        <mf-search v-model="search" class="mt-5" label="Buscar produto"></mf-search>
      </v-card-title>
      <v-card-text class="pt-0 mt-0 px-4">
        <v-data-table
          fixed-header
          disable-pagination
          hide-default-footer
          :headers="headers"
          :items="products"
          :search="search"
          :height="products.length > 3 ? '330px' : ''"
        >
          <template v-slot:item="{ item, index }">
            <tr>
              <td class="nowrap-row">
                <v-tooltip max-width="250" top>
                  <template #activator="{ on }">
                    <span v-on="on">
                      {{ getFormatedText(item.name) }}
                    </span>
                  </template>
                  <span>{{ item.name }}</span>
                </v-tooltip>
              </td>
              <td class="text-end">
                <v-tooltip max-width="250" top :disabled="!appSales">
                  <template v-slot:activator="{ on }">
                    <span v-on="on">
                      <mf-button icon="delete" color="cinza-0" type="icon" :disabled="appSales" @click="deleteProducts(item)" />
                    </span>
                  </template>
                  <span>Não é permitido remover produtos de uma oferta por aqui. Para desativar um produto altere a gestão de ofertas.</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
        <mf-action-buttons
          :primary-button="{
            text: 'Fechar',
            action: () => (openAllMenu = false),
            isVisible: true,
          }"
        />
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import truncate from 'lodash/truncate'
import cloneDeep from 'lodash/cloneDeep'
export default {
  name: 'AllProductsMenu',
  props: {
    products: {
      type: Array,
    },
    appSales: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    openAllMenu: false,
    search: '',
  }),
  computed: {
    productsList: {
      get() {
        return this.products
      },
      set(value) {
        this.$emit('update:products', value)
      },
    },
    headers() {
      return [
        {
          text: 'Nome',
          value: 'name',
          width: '100%',
          sortable: false,
        },
        {
          text: '',
          value: 'actions',
          sortable: false,
        },
      ]
    },
    cardTitle() {
      return 'Produtos no grupo'
    },
    cardText() {
      return this.removeAllEmails
        ? 'Tem certeza que deseja excluir todos os e-mails da lista?'
        : 'Tem certeza que deseja excluir esse e-mail da lista de preview?'
    },
  },
  methods: {
    getFormatedText(text) {
      return truncate(text, {
        length: 25,
        separator: ' ',
      })
    },
    deleteProducts(item) {
      const list = cloneDeep(this.products)
      const index = list.findIndex((itemToFindIndex) => {
        return itemToFindIndex._id === item._id
      })
      list.splice(index, 1)
      this.productsList = list
      this.$emit('remove', index)
    },
  },
}
</script>
<style scoped lang="scss">
::v-deep th,
::v-deep td {
  font-size: 14px !important;
  color: $cinza-d20 !important;
}
::v-deep td {
  height: 40px !important;
}
</style>
